import { DragDropContext } from 'react-beautiful-dnd';
import { ReactNode, useRef } from 'react';
import styled from 'styled-components';

const StyledTable = styled.div`
  border-collapse: collapse;
  display: table;
  width: 100%;
`;

type Props = {
  children: ReactNode;
  columnOrder: string[];
  setColumnOrder: (arg: string[]) => void;
};

export const DraggableTable = ({ children, columnOrder, setColumnOrder, ...props }: Props) => {
  const currentColOrder = useRef<any>();

  return (
    <StyledTable data-test="table" role="table" {...props}>
      <DragDropContext
        onDragStart={() => {
          currentColOrder.current = columnOrder;
        }}
        onDragUpdate={(dragUpdateObj) => {
          const colOrder = [...currentColOrder.current];
          const sIndex = dragUpdateObj.source.index;
          const dIndex = dragUpdateObj.destination && dragUpdateObj.destination.index;

          if (typeof sIndex === 'number' && typeof dIndex === 'number') {
            colOrder.splice(sIndex, 1);
            colOrder.splice(dIndex, 0, dragUpdateObj.draggableId);
            setColumnOrder(colOrder);
          }
        }}
        onDragEnd={() => {
          // Adding comment so lint won't be angry. Not needed for implementation. Logic handled in dragUpdate.
        }}
      >
        {children}
      </DragDropContext>
    </StyledTable>
  );
};
